import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Features } from '@/shared/types/account';

const defaultState: Features = {};

// This slice is used to store the feature flags accesible from redux store.
// It is loaded by the `useFeatureFlag` hook.
const slice = createSlice({
  name: 'featureFlags',
  initialState: defaultState,
  reducers: {
    setFeatureFlags: (state: Features, action: PayloadAction<Features>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setFeatureFlags } = slice.actions;
export default slice.reducer;
